// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"d40d2c96","453":"b1963a9f","519":"03bd3197","699":"0a865423","787":"3e3cda7b"}[chunkId] + ".chunk.js";
};